import React from "react";
import { Box, Typography, Container, Divider } from "@mui/material";
 
const TermsAndConditions = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Terms and Conditions
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center" sx={{ mb: 5 }}>
        Last updated: March 1, 2025
      </Typography>
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          1. Introduction
        </Typography>
        <Typography paragraph>
          Welcome to Del Toro Insurance. These Terms and Conditions govern your use of our website and the services we provide. By accessing our website or using our services, you agree to these Terms and Conditions in full. If you disagree with any part of these terms, please do not use our website or services.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          2. Definitions
        </Typography>
        <Typography paragraph>
          "Company," "we," "us," or "our" refers to Del Toro Insurance and its subsidiaries.
        </Typography>
        <Typography paragraph>
          "Website" refers to deltoro-insurance.com and all related domains and subdomains.
        </Typography>
        <Typography paragraph>
          "Services" refers to insurance products, quotes, claims processing, and all other services offered by Del Toro Insurance.
        </Typography>
        <Typography paragraph>
          "User," "you," or "your" refers to the individual or entity accessing our website or using our services.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          3. Website Use
        </Typography>
        <Typography paragraph>
          The content of this website is for general information and reference purposes only. We make reasonable efforts to update the information on our website, but we make no representations, warranties, or guarantees, whether express or implied, that the content is accurate, complete, or up to date.
        </Typography>
        <Typography paragraph>
          Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It is your responsibility to ensure that any products, services, or information available through this website meet your specific requirements.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          4. Insurance Services
        </Typography>
        <Typography paragraph>
          Del Toro Insurance offers various insurance products and services. All insurance policies are subject to the terms, conditions, limitations, and exclusions contained in the specific policy documents. In the event of a conflict between these Terms and Conditions and the provisions of any policy document, the policy document will govern.
        </Typography>
        <Typography paragraph>
          Insurance quotes provided through our website or by our representatives are estimates based on the information you provide. Final premiums and coverage are subject to underwriting approval and verification of the information provided.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          5. Privacy Policy
        </Typography>
        <Typography paragraph>
          Your use of our website and services is also governed by our Privacy Policy, which can be found at [Privacy Policy Link]. By using our website or services, you consent to the collection and use of your information as described in our Privacy Policy.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          6. Changes to Terms
        </Typography>
        <Typography paragraph>
          We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website or our services after any changes indicates your acceptance of the modified Terms and Conditions.
        </Typography>
      </Box>
    </Container>
  );
};
 
export default TermsAndConditions;
 